module.exports = __webpack_public_path__ + "assets/images/786e45e6c5a9b74e836e32e176b39a27.png";